import type { UIMessage } from "ai";

export function appendUserTextMessage(
  messages: UIMessage[],
  text: string,
  metadata?: unknown
): UIMessage[] {
  const trimmed = text.trim();
  if (!trimmed) return messages;
  return [
    ...messages,
    {
      id: globalThis.crypto?.randomUUID?.() ?? `user-${Date.now()}`,
      role: "user",
      metadata,
      parts: [{ type: "text", text: trimmed }],
    },
  ];
}
